import React from 'react';
import { LoadingIndicator } from '~/components/ui/LoadingIndicator';
import Cleave from 'cleave.js/react';
import cn from 'classnames';
import { FaHeart } from 'react-icons/fa';

export function InfluencerSmsForm(props: {
  loading: any;
  onSubmit: (e: React.SyntheticEvent) => Promise<void>;
  value: string;
  onChange: (e: React.SyntheticEvent<HTMLInputElement>) => void;
  error: any;
  valid: null | boolean;
  numRegistered: number;
  isStreamChosen: boolean;
  optInText: string;
}) {
  return (
    <div>
      {props.loading && (
        <LoadingIndicator blockScreen={true} message={'Signing up...'} />
      )}

      <p className={cn(props.isStreamChosen ? 'mt-0' : 'mt-6', 'mb-3')}>
        Sign up to get a text reminder before the event!
      </p>

      <form className={'md:flex'} onSubmit={props.onSubmit}>
        <div className={'flex-1'}>
          <label
            htmlFor="phone"
            className=" block text-xs mb-1 text-gray-600 font-semibold"
          >
            Phone Number
          </label>

          <Cleave
            placeholder={'+1 (555) 555-5555'}
            options={{
              blocks: [2, 0, 3, 0, 3, 4],
              delimiters: [' ', '(', ')', ' ', '-'],
            }}
            pattern="^\+1 \(\d{3}\)\s\d{3}-\d{4}"
            value={props.value}
            onChange={props.onChange}
            required={true}
            type="tel"
            name="phone"
            id="phone"
            className="block w-full border border-gray-300 rounded-md p-2"
            style={{ height: 48 }}
          />

          {props.error && (
            <div
              className={
                'my-4 px-4 py-2 bg-red text-white font-semibold rounded'
              }
            >
              There was a problem signing you up
            </div>
          )}
        </div>

        <button
          type="submit"
          className={cn(
            'md:flex-0 md:ml-3 md:w-auto md:px-7 mt-4 w-full flex items-center justify-center p-4 rounded-lg text-base text-white relative top-1',
            props.valid && 'font-bold',
          )}
          style={{
            backgroundColor: props.valid ? 'black' : '#F2F2F2',
            ...(!props.valid ? { color: '#666666' } : {}),
            height: 48,
          }}
        >
          Remind Me!
        </button>
      </form>

      {!props.isStreamChosen && (
        <div className={'text-center'}>
          {props.numRegistered > 10 && (
            <p className={'text-xs mt-3 text-gray-500'}>
              <FaHeart className={'mr-4 inline'} color={'red'} />
              {props.numRegistered}{' '}
              {props.numRegistered > 1 ? 'people' : 'person'} registered
            </p>
          )}
        </div>
      )}

      <p className={'text-xs my-4'}>{props.optInText}</p>
    </div>
  );
}
